import './App.css';
import L, { Icon } from "leaflet";
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Loader from './Loader';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import DraggableMarker from './DraggableMarker';

delete L.Icon.Default.prototype._getIconUrl;


const green = new Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
const centerPos = {
  lat: 42.724,
  lng: 25.49,
}
function App() {
  const [userLocation, setUserLocation] = useState(null)
  const [map, setMap] = useState(null);
  const [show, setShow] = useState(false);

  const [position, setPosition] = useState(centerPos)
  const [distance, setDistance] = useState(0)
  const [isFirst, setIsFirst] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });
        },

        (error) => {
          console.error("Error get user location: ", error);
        },
        { timeout: 5000 }
      );
    } else {
      console.log("Geolocation is not supported by this browser");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getUserLocation(), 10);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const distance = calculateDistance(userLocation?.latitude, userLocation?.longitude, position?.lat, position?.lng)

    formatDistance(distance);
    setDistance(formatDistance(distance));
    if (isFirst && userLocation) {
      const { latitude, longitude } = userLocation;

      setPosition({
        lat: latitude - 0.15,
        lng: longitude - 0.15,
      });
      setIsFirst(false)
    }
  }, [position, userLocation, isFirst]);


  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRadians = (degrees) => (degrees * Math.PI) / 180;

    const R = 6371; // Radius of Earth in kilometers
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const lat1Rad = toRadians(lat1);
    const lat2Rad = toRadians(lat2);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1Rad) *
      Math.cos(lat2Rad) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km

    return distance;
  };

  const formatDistance = (distanceInKm) => {
    if (distanceInKm < 1) {
      const distanceInMeters = Math.round(distanceInKm * 1000); // Convert to meters and round
      return `${distanceInMeters} m`;
    } else if (distanceInKm >= 1) {
      return `${distanceInKm?.toFixed(3)} km`; // Show 1 decimal point for kilometers
    } else {
      return `0 m`;
    }
  };

  const setCurrentPositionMarker = () => {
    const { latitude, longitude } = userLocation;

    setPosition({
      lat: latitude,
      lng: longitude,
    })
  }

  const setCenterPositionMarker = () => {
    setPosition(map.getCenter())
  }

  return (
    <>{!userLocation && <Loader />}
      {userLocation && <MapContainer ref={setMap} center={[userLocation?.latitude, userLocation?.longitude]} zoom={10} scrollWheelZoom={true}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <DraggableMarker position={position} setPosition={setPosition} />
        {userLocation && <Marker icon={green} position={[userLocation.latitude, userLocation.longitude]}>

        </Marker>}
      </MapContainer>}
      {userLocation && <div className="controls">
        <div className="d-flex">
          <div className="w-100">
            <Button variant="secondary" className='mx-2' onClick={setCurrentPositionMarker}>
              Set marker here
            </Button>
            <Button variant="secondary" className='mx-2' onClick={setCenterPositionMarker}>
              Set marker in center
            </Button>
            {userLocation && (
              <div>
                <h2>Distance: {distance}</h2>
              </div>
            )}

            <Button variant="secondary" onClick={handleShow}>
              Full Screen
            </Button>

          </div>
        </div>
      </div>}
      <Modal show={show} onHide={handleClose} animation={true} fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title>Distance</Modal.Title>
        </Modal.Header>
        <Modal.Body className='d-flex justify-content-center align-items-center'><p className="full-screen-text">{distance}</p></Modal.Body>
      </Modal>
    </>
  );
}

export default App;
